import React from 'react';
import { Pencil, Trash2 } from 'lucide-react';

const RuleActionList = ({
  actions,
  getSummary,
  editingIndex,
  onEdit,
  onDelete
}) => (
  <div className="rule-action-list">
    {actions.map((action, index) => {
      const summary = getSummary(action);
      const number = index + 1;

      return (
        <div
          key={index}
          className={`rule-action-row ${editingIndex === index ? 'is-editing' : ''}`}
        >
          <div className="rule-action-index" aria-hidden="true">
            {number}
          </div>
          <button
            type="button"
            className="rule-action-summary"
            onClick={() => onEdit(index)}
            aria-label={`编辑动作 ${number}`}
          >
            <span className="rule-action-summary-heading">
              <strong>{summary.title}</strong>
              <span>{summary.detail}</span>
            </span>
            {summary.meta && (
              <span className="rule-action-summary-meta">{summary.meta}</span>
            )}
          </button>
          <div className="rule-action-commands">
            <button
              type="button"
              className="condition-icon-button"
              onClick={() => onEdit(index)}
              aria-label={`编辑动作 ${number}`}
              title="编辑动作"
            >
              <Pencil size={15} aria-hidden="true" />
            </button>
            <button
              type="button"
              className="condition-icon-button condition-delete-button"
              onClick={() => onDelete(index)}
              aria-label={`删除动作 ${number}`}
              title="删除动作"
            >
              <Trash2 size={15} aria-hidden="true" />
            </button>
          </div>
        </div>
      );
    })}
  </div>
);

export default RuleActionList;
